/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { forgotPasswordPostRequestSchema } from './forgotPasswordPostRequestSchema.ts';
import { forgotPasswordPostResponseSchema } from './forgotPasswordPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postForgotPassword200Schema = z.lazy(() => forgotPasswordPostResponseSchema);

/**
 * @description 505 response
 */
export const postForgotPassword505Schema = z.any();

export const postForgotPasswordMutationRequestSchema = z.lazy(() => forgotPasswordPostRequestSchema);

export const postForgotPasswordMutationResponseSchema = z.lazy(() => postForgotPassword200Schema);
